import { createContext, PropsWithChildren, useContext } from 'react';

const SideNavExpandedContext = createContext<boolean | undefined>(undefined);

export function SideNavExpandedProvider({
  expanded,
  children,
}: PropsWithChildren<{ readonly expanded: boolean }>) {
  return (
    <SideNavExpandedContext.Provider value={expanded}>
      {children}
    </SideNavExpandedContext.Provider>
  );
}

export function useSideNavExpanded(): boolean {
  return useContext(SideNavExpandedContext) ?? true;
}
